module.exports = __webpack_public_path__ + "img/pos-id-close.e9f8fe23.svg";